<script setup>
  import { storeToRefs } from "pinia";
  import { useRouter } from "vue-router";
  import PricerProjectsTable from "@/components/Admin/Pricer/PricerProjectsTable.vue";
  import { IndexPageLayout, IndexPageFilters } from "@/components/App/IndexPage";
  import { FilterDropdown } from "@/components/episto-ui/filter-dropdown";
  import { usePricerProjectsStore } from "@stores/pricer/pricerProjects";
  import { usePricerProjectsFilters } from "@/utils/composables/filters/usePricerProjectsFilters";

  const router = useRouter();
  const pricerProjectsStore = usePricerProjectsStore();
  const { projectsSearchQuery, projectsCount } = storeToRefs(pricerProjectsStore);

  const { filterConfigs, activeFiltersCount, handleFilterChange, handleClear } = usePricerProjectsFilters();

  const create = () => router.push({ name: "PricerProjectNew" });
</script>

<template>
  <IndexPageLayout
    title="Pricer"
    action-label="New project"
    @action="create">
    <template #filters>
      <IndexPageFilters
        v-model:search-model-value="projectsSearchQuery"
        search-placeholder="Search projects">
        <template #filters>
          <FilterDropdown
            :filters="filterConfigs"
            :active-filters-count="activeFiltersCount"
            :matching-count="projectsCount"
            matching-label="projects"
            @toggle="handleFilterChange"
            @clear="handleClear" />
        </template>
      </IndexPageFilters>
    </template>

    <PricerProjectsTable />
  </IndexPageLayout>
</template>
